import * as currencies from '@dinero.js/currencies';
import dinero from 'dinero.js';

import { type CurrencyCode } from 'hb-react/types';

export const money = (amount = 0, currencyCode: CurrencyCode = 'USD') => {
  const amountNumber = parseFloat(amount.toString());

  return {
    total: amountNumber,
    cents: dinero({
      amount: Math.round(
        10 ** currencies[currencyCode].exponent * amountNumber,
      ),
      currency: currencyCode,
      precision: currencies[currencyCode].exponent,
    }).getAmount(),
  };
};

export const moneyFromCents = (cents, currencyCode: CurrencyCode = 'USD') => ({
  total: dinero({
    amount: cents,
    currency: currencyCode,
    precision: currencies[currencyCode].exponent,
  }).toUnit(),
  cents,
});

export const validateCents = (selectedCurrency, setHasCents) => {
  if (selectedCurrency.has_cents) {
    setHasCents(true);
  } else {
    setHasCents(false);
  }
};
